import React, { useState } from "react";
import Header from "./Header";
import LocationDetails from "./LocationDetails";

type FormState = { name: string; email: string; phone: string; message: string };
type Errors = Partial<Record<keyof FormState, string>>;

export default function Contact() {
  const [form, setForm] = useState<FormState>({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState<Errors>({});
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const errs: Errors = {};
    if (!form.email) errs.email = "Email is required";
    if (!form.phone) errs.phone = "Phone number is required";
    if (!form.message) errs.message = "Message is required";

    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }

    setSubmitting(true);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          access_key: "c637983e-a9b8-4c2c-a128-d3ed9646e368", // replace with your Web3Forms access key
          name: form.name,
          email: form.email,
          phone: form.phone,
          message: form.message,
          subject: "New Contact Form Submission from Ely Wine Bar",
          redirect: "", // leave blank to stay on page
        }),
      });

      const data = await response.json();

      if (data.success) {
        alert("Your message has been sent successfully!");
        setForm({ name: "", email: "", phone: "", message: "" });
      } else {
        alert("Failed to send message. Please try again later.");
        console.error(data);
      }
    } catch (error) {
      console.error(error);
      alert("An error occurred. Please try again later.");
    }

    setSubmitting(false);
  };

  return (
    <>
      <Header />
      <div className="container py-5">
        <div className="row align-items-start">
          <div className="col-md-6 mb-4">
            <h2
              className="fw-semibold display-6"
              style={{ fontFamily: "EagleBold", color: "#155d68" }}
            >
              Contact Us
            </h2>
            <p className="text-muted">
              Need help? If you have any questions about an order, a voucher or a booking, our team at ELY Wine Bar, Dublin 2 will be 
              delighted to help. <br />
              <br />
              Looking to book a private or group event? <br />
              <a href="https://form.jotform.com/212653008716048" target="_blank" rel="noreferrer"> Click here to submit your booking request.</a>
            </p>
          </div>

          <div className="col-md-6">
            <form noValidate onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Your Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter your name"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Your Email Address*</label>
                <input
                  type="email"
                  className={`form-control ${
                    errors.email ? "is-invalid border-danger" : ""
                  }`}
                  placeholder="Enter your email address"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  disabled={submitting}
                />
                {errors.email && (
                  <div className="invalid-feedback d-block">
                    {errors.email}
                  </div>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">Your Phone Number*</label>
                <input
                  type="tel"
                  className={`form-control ${
                    errors.phone ? "is-invalid border-danger" : ""
                  }`}
                  placeholder="Enter your phone number"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  disabled={submitting}
                />
                {errors.phone && (
                  <div className="invalid-feedback d-block">
                    {errors.phone}
                  </div>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">Your Message*</label>
                <textarea
                  className={`form-control ${
                    errors.message ? "is-invalid border-danger" : ""
                  }`}
                  placeholder="Type your message here"
                  rows={4}
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  disabled={submitting}
                ></textarea>
                {errors.message && (
                  <div className="invalid-feedback d-block">
                    {errors.message}
                  </div>
                )}
              </div>

              <button
                type="submit"
                className="btn rounded-pill px-4 text-white"
                style={{
                  backgroundColor: "#155d68",
                  border: "none",
                  fontFamily: "EagleLight",
                }}
                disabled={submitting}
              >
                {submitting ? "Sending..." : "Submit Your Enquiry"}
              </button>
            </form>
          </div>
        </div>
      </div>
      <LocationDetails />
    </>
  );
}
